var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('MainHeader'),_vm._t("default"),_c('GotoTop'),_c('MainFooter'),_c('transition',{attrs:{"name":"fade"}},[(_vm.isLoading)?_c('Loading',{on:{"close":function($event){_vm.isLoading = $event}}}):_vm._e()],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }